module.exports = __webpack_public_path__ + "static/apple-icon-180x180-dd4a0ecb1845102fa68a5967a41c162f.png";